import React, { useEffect, useContext } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { RHFSelect } from "../RFHSelect/RFHSelect";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";
import { useForm, FormProvider } from "react-hook-form";

export const AddVideoDialog = ({ open, onClose, onAdd, allVideos }) => {
  const { darkMode } = useContext(ThemeContext);
  const methods = useForm({
    displayname: "",
    videolink: "",
    vimeolink: "",
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = methods;

  const generateRandomKey = (allVideos) => {
    const isDuplicate = (key) =>
      allVideos.some((video) => video.randomkey === key);

    let randomKey = Math.floor(10000000 + Math.random() * 90000000);
    while (isDuplicate(randomKey)) {
      randomKey = Math.floor(10000000 + Math.random() * 90000000);
    }
    return randomKey;
  };

  useEffect(() => {
    setValue("displayname", "");
    setValue("videolink", "BackOnTrac.mp4");
    setValue("vimeolink", "");
  }, [open, setValue]);

  const onSubmit = (data) => {
    const newVideoData = {
      displayname: data.displayname,
      videolink: data.videolink,
      vimeolink: data.vimeolink,
      randomkey: generateRandomKey(), // Assign the unique random key
    };

    onAdd(newVideoData);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <DialogTitle sx={{ fontSize: "30px", pb: 0 }}>Add Video</DialogTitle>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent sx={{ pt: 0 }}>
            <FormControl fullWidth margin="normal">
              <TextField
                label="Video Name"
                placeholder="Enter Video Name"
                {...register("displayname", {
                  required: "Video Name is required",
                })}
                error={!!errors.displayname}
                helperText={errors.displayname?.message}
              />
            </FormControl>

            {/* Frequency Dropdown */}
            <FormControl fullWidth margin="normal">
              <InputLabel>Video Link</InputLabel>
              <RHFSelect
                name="videolink"
                error={!!errors.videolink}
                helperText={errors.videolink?.message}
              >
                {[...new Set(allVideos.map((video) => video.videolink))].map(
                  (uniqueLink) => (
                    <MenuItem key={uniqueLink} value={uniqueLink}>
                      {uniqueLink}
                    </MenuItem>
                  )
                )}
              </RHFSelect>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <TextField
                label="Vimeo Link"
                multiline
                rows={4}
                placeholder="Enter Vimeo Link"
                {...register("vimeolink", {})}
                error={!!errors.vimeolink}
                helperText={errors.vimeolink?.message}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                borderRadius: "5px",
                fontFamily: "Poppins",
                fontSize: "18px",
                fontWeight: 500,
                color: darkMode
                  ? getColors.appBarBgLight
                  : getColors.appBarBgDark,
                px: 4,
                py: "11px",
                textAlign: "center",
                "&: hover": {
                  background: "none",
                  color: getColors.primaryMain,
                },
              }}
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              variant="contained"
              sx={{
                borderRadius: "5px",
                fontFamily: "Poppins",
                fontSize: "18px",
                fontWeight: 500,
                px: 5,
                py: "11px",
                textAlign: "center",
              }}
            >
              Add
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};
